import { StyleSheet } from 'react-native';

import { EPGConfig } from '../types';

const getStyles = (config: EPGConfig) =>
    StyleSheet.create({
        container: {
            position: 'absolute',
            top: config.timebarHeight,
            left: 0,
            bottom: 0,
            width: config.channelWidth,
        },
    });

export default getStyles;
